(function() {
    'use strict';

    angular
        .module('atheer.insights', [

        ]);
})();